import { AnyEvent } from './ClickOutsideGlobal';

export const isDOMElementContainsTarget = <El extends HTMLElement>(
  el: El,
  event: AnyEvent,
) => el.contains(event.target as Node);
